/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ChangeDetectionStrategy, Component } from '@angular/core';

import { AelNavigationParams } from '@gh/builder-shared';
import { AelEvents, getAelEventsArray } from '@gh/builder-shared-data';

import { AbstractScheduleDetailsComponent } from '../abstract-schedule-details.component';
import { ScheduleDetailsCommandService } from '../schedule-details-command.service';
import { ScheduleDetailsFormState } from '../schedule-details-form.service';

@Component({
  standalone: false,
  selector: 'gh-construction-schedule-details',
  templateUrl: 'construction-schedule-details.component.html',
  providers: [ScheduleDetailsFormState, ScheduleDetailsCommandService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConstructionScheduleDetailsComponent extends AbstractScheduleDetailsComponent {
  baseRoutePath = 'schedules/construction';
  titlePrefix = 'lbl_construction_sch_for_job';

  constructor(public form: ScheduleDetailsFormState,
              commands: ScheduleDetailsCommandService) {
    super(commands);
  }

  buildAelNavigationParams(): AelNavigationParams {
    return {
      label: 'lbl_construction_sch',
      entityType: 'JOB',
      entityId: this.form.jobId,
      eventTypeIds: getAelEventsArray(AelEvents.Job.ConstructionSchedule),
    };
  }
}
